import { render } from "./TabWebTemplate.vue?vue&type=template&id=1349ac7d&scoped=true"
import script from "./TabWebTemplate.vue?vue&type=script&lang=js"
export * from "./TabWebTemplate.vue?vue&type=script&lang=js"

import "./TabWebTemplate.vue?vue&type=style&index=0&id=1349ac7d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1349ac7d"]])

export default __exports__